<template>
    <div v-if="saison">
        <v-row :class="[{'px-5': $vuetify.breakpoint.smAndDown},
                        {'px-2': $vuetify.breakpoint.mdAndUp}, 'align-center ']" no-gutters >
            <v-col xl="3" lg="4" md="6" sm="6" cols="12"
                   :class="[{'pb-1': $vuetify.breakpoint.xsOnly}]">
                <v-radio-group hide-details v-model="timeFrame" row>
                    <v-radio v-for="timeFrame in timeFrameValues" :key="timeFrame.value"
                             class="my-0" :label="timeFrame.label" :value="timeFrame.value">
                        <template v-slot:label><span class="body-2">{{timeFrame.label}}</span></template>
                    </v-radio>
                </v-radio-group>
            </v-col>
            <v-col xl="3" lg="4" md="6" sm="6" cols="12"
                   :class="[{'pb-1': $vuetify.breakpoint.xsOnly},
                            {'pl-10': $vuetify.breakpoint.mdAndUp}]">
                <v-radio-group  hide-details v-model="location" row>
                    <v-radio v-for="location in locationValues" :key="location.value"
                             class="my-0" :label="location.label" :value="location.value">
                        <template v-slot:label><span class="body-2">{{location.label}}</span></template>
                    </v-radio>
                </v-radio-group>
            </v-col>
            <v-col xl="3" lg="4" md="6" sm="6" cols="12"
                   :class="[{'pb-4': $vuetify.breakpoint.mdAndDown},
                            {'pl-10': $vuetify.breakpoint.lgAndUp}]">
                <v-radio-group  hide-details v-model="showByTeam" row>
                    <v-radio class="my-0" :value="false">
                        <template v-slot:label><span class="body-2">nach Verein</span></template>
                    </v-radio>
                    <v-radio class="my-0" :value="true">
                        <template v-slot:label><span class="body-2">nach Mannschaft</span></template>
                    </v-radio>
                </v-radio-group>
            </v-col>
            <v-col v-if="schnittliste.length>0"
                   xl="3" lg="3" md="6" sm="6" cols="12"
                   :class="[{'text-right pt-4': $vuetify.breakpoint.xlOnly },
                            {'pt-3': $vuetify.breakpoint.smOnly },
                            {'pl-10 pt-3': $vuetify.breakpoint.mdOnly },
                            {'mt-5': $vuetify.breakpoint.lgOnly},
                            {'pb-3': $vuetify.breakpoint.lgAndDown}]">
                <v-select dense hide-details class="d-inline-block" style="max-width: 70px"
                        v-model="spieleMin" outlined :items="anzahlSpiele">
                </v-select>
                <div class="d-inline-block ml-2 mr-2">Spiel(e) absolviert</div>
            </v-col>
            <v-col v-if="schnittliste.length>0"
                   xl="12" lg="9" md="12" sm="12" cols="12"
                   :class="['pb-3',
                            {'mt-5': $vuetify.breakpoint.lgAndUp},
                            {'pl-0': $vuetify.breakpoint.xlOnly}]">
                <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" style="width: 100%"
                              label="Suchen" filled dense single-line hide-details  >
                    <template v-slot:append>
                        <v-btn icon small class="pb-2">
                            <v-icon style="cursor: pointer" @click="search=''">mdi-close</v-icon>
                        </v-btn>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>
        <div :class="[{'pl-5 mb-3': $vuetify.breakpoint.xsOnly},
                      {'pl-2 mb-1': $vuetify.breakpoint.smAndUp}]">
            Von Runde
            <v-text-field v-model="roundFrom" class="d-inline-block px-1 numberInput"
                          type="number" filled dense single-line
                          hide-details clearable>
            </v-text-field>
            bis
            <v-text-field v-model="roundUntil" class="d-inline-block pl-1 numberInput"
                          type="number" filled dense single-line
                          hide-details clearable>
            </v-text-field>
        </div>
        <div :class="[{'px-5': $vuetify.breakpoint.smAndDown},
                      {'px-3': $vuetify.breakpoint.mdAndUp}, 'caption']"
            v-if="schnittliste.length>0">
            <v-row align="center">
                <v-col class="grow">
                    Klicke auf eine Fahne, die Altersklasse oder einen Verein um zu filtern, nochmaliges Klicken löscht den Filter.
                </v-col>
                <v-col class="shrink" style="position: relative" v-if="$vuetify.breakpoint.mdAndUp">
                    <download-to-excel class="mt-n2 mr-n1"
                                       :json-list="schnittliste"
                                       sheet-name="Schnittliste"
                                       :file-time-stamp="null"
                                       :config="headersExcel"/>
                </v-col>
                <v-col class="shrink" v-if="$vuetify.breakpoint.mdAndUp">
                    <v-btn icon @click="print()"><v-icon>mdi-printer</v-icon></v-btn>
                </v-col>
            </v-row>
        </div>
        <v-data-table :headers="headers" :items="schnittliste" hide-default-header
                      hide-default-footer
                      mobile-breakpoint="1" :sort-by.sync="sortBy" :must-sort="true"
                      :sort-desc.sync="sortDesc" :search="search" dense disable-pagination
                      :class="[{'elevation-0 mt-0 mb-10': $vuetify.breakpoint.smAndDown},
                                {'mt-5': $vuetify.breakpoint.lgAndUp},
                                {'elevation-4 mx-2 mt-2': $vuetify.breakpoint.mdAndUp}, 'mb-2']">
            <template v-slot:header="{}">
                <tr class="px-0" >
                    <th class="headerCell py-2"></th>
                    <th class="headerCell py-2"></th>
                    <td class="headerCell py-2">Pass</td>
                    <th class="headerCell py-2"></th>
                    <th class="headerCell py-2 text-left px-2">Name</th>
                    <th class="headerCell py-2 text-left px-4">
                        <span v-if="!showByTeam">Verein</span>
                        <span v-else>Mannschaft</span>
                    </th>
                    <td class="headerCell py-2 text-center">Heim</td>
                    <td class="headerCell py-2 text-center pr-2">Spiele</td>
                    <td class="headerCell py-2 text-center">Gast</td>
                    <td class="headerCell py-2 text-center pr-2">Spiele</td>
                    <td class="headerCell py-2 text-center">Gesamt</td>
                    <td class="headerCell py-2 text-center pr-2">Spiele</td>
                </tr>
            </template>
            <template v-slot:item="{ index, item }">
                <tr>
                    <td class="pr-0">
                        <span v-if="item[location + 'Schnitt' + timeFrame] !== '0.00' && !search">
                        {{saison.getSchnittlistenPos(item, location, timeFrame)}}</span>
                        <span v-if="item[location + 'Schnitt' + timeFrame] !== '0.00' && search">
                        {{saison.getSchnittlistenPos(item, location, timeFrame)}}</span>
                        <span v-if="search" class="grey--text">
                             ({{index+1}})
                        </span>
                    </td>
                    <td class="px-0 linkCol" @click="quickSearch(item.nationalitaet)">
                        <v-hover v-slot="{ hover }">
                        <flag :iso="flags[item.nationalitaet]" :squared="false"
                                :class="[{ 'flagHover': hover },
                                         { 'elevation-4': !hover }, 'ma-2 d-inline-block']">
                            {{item.nationalitaet}}
                        </flag>
                        </v-hover>
                    </td>
                    <td class="py-2 px-0">
                        <span v-if="item.passNr.indexOf('f')===0">-</span>
                        <span v-else>{{item.passNr}}</span>
                    </td>
                    <td class="px-2 linkCol" @click="quickSearch(getAltersklasse(item))">
                        <v-hover v-slot="{ hover }">
                            <span :class="{ 'primary--text': hover }">{{getAltersklasse(item)}}</span>
                        </v-hover>
                    </td>
                    <td class="pr-0 pl-2">
                        <span @click="tableAction(item.id, item.passNr, item.team, 'spielerPerformanceSchnittliste')"
                            class="text-decoration-underline" style="cursor: pointer">
                            {{item.name}}
                        </span>
                    </td>
                    <td v-if='!showByTeam'
                        class="pr-2 borderRight linkCol" @click="quickSearch(item.verein)">
                        <v-hover v-slot="{ hover }">
                            <span :class="{ 'primary--text': hover }">{{item.verein}}</span>
                        </v-hover>
                    </td>
                    <td v-else @click="quickSearch(item.team)" class="pr-2 borderRight linkCol" >
                        <v-hover v-slot="{ hover }">
                            <span :class="{ 'primary--text': hover }">{{item.team}}</span>
                        </v-hover>
                    </td>
                    <td :class="[{'font-weight-bold': location==='heim'}, 'pl-3 pr-2 text-right']">
                        <schnitt-feld :value="item['heimSchnitt' + timeFrame]"></schnitt-feld>
                    </td>
                    <td :class="[{'font-weight-bold': location==='heim'}, 'pl-3 pr-4 text-center borderRight']">
                                {{item['heimSpiele' + timeFrame]}}</td>
                    <td :class="[{'font-weight-bold': location==='gast'}, 'pl-3 pr-2 text-right']">
                        <schnitt-feld :value="item['gastSchnitt' + timeFrame]"></schnitt-feld>
                    </td>
                    <td :class="[{'font-weight-bold': location==='gast'}, 'pl-3 pr-4 text-center borderRight']">
                                {{item['gastSpiele' + timeFrame]}}</td>
                    <td :class="[{'font-weight-bold': location==='total'}, 'pl-3 pr-2 text-right']">
                        <schnitt-feld :value="item['totalSchnitt' + timeFrame]"></schnitt-feld>
                    </td>
                    <td :class="[{'font-weight-bold': location==='total'}, 'pl-3 pr-4 text-center']">
                                {{item['totalSpiele' + timeFrame]}}</td>
                </tr>
            </template>
            <template v-slot:no-data>
                Für diese Auswahl kann noch keine Schnittliste berechnet werden!
            </template>
        </v-data-table>
        <spieler-performance action="spielerPerformanceSchnittliste"
                             :saison="saison"
                             :spieler-id="selectedSpieler"
                             :pass-nr="selectedSpielerPassNr"
                             :team="selectedTeam"
                             :timeFrame="timeFrame">
        </spieler-performance>
    </div>
</template>

<script>
    import SchnittFeld from "./components/schnittFeld";
    import SpielerPerformance from "./spielerPerformance";
    import {db} from "../../services/db";
    import SpielService from "../../services/data/spielService";
    import DownloadToExcel from "@/utilities/components/downloads/downloadToExcel";

    export default {
        components: {
            DownloadToExcel,
            SpielerPerformance,
            SchnittFeld},
        name: "schnittlisten",
        props: ['saison'],
        computed: {
            flags(){ return this.$store.state.local.countryIso },
            /*flags(){
                let list=[];
                Object.keys(this.$store.state.local.countryIso).forEach( (isoKey) => {
                    list.push({text: isoKey, flag: this.$store.state.local.countryIso[isoKey]})
                });
                return list;
            },*/
            anzahlSpiele(){
                const spiele = this.location + 'Spiele' + this.timeFrame;
                let max = 0;
                this.schnittliste.forEach( (item) => {
                    if ( max < item[spiele] ) { max = item[spiele] }
                });
                let list = [];
                for ( let i = 0; i <= max; i++ ) {
                    list.push(i);
                }
                if ( list.length === 0 ) { list = [0,1] }
                return list;
            },
            schnittliste(){
                if ( this.saison ) {
                    const spiele = this.location + 'Spiele' + this.timeFrame;
                    return this.saison.local.schnittliste
                        .filter(spieler => spieler[spiele] >= this.spieleMin )
                        .map(spieler=> ({ ...spieler,
                            ak: SpielService.getAltersklasse(spieler.akHJ, spieler.akJahr, this.saison.id) }))
                } else {
                    return [];
                }
            }
        },
        data: () => ({
            search: null,
            roundFrom: null,
            roundUntil: null,
            spieleMin: 1,
            timeFrame: 'T',
            timeFrameValues: [ {label: 'Herbst', value: 'H'}, {label: 'Frühjahr', value: 'F'}, {label: 'Gesamt', value: 'T'} ],
            location: 'total',
            locationValues: [ {label: 'Heim', value: 'heim'}, {label: 'Gast', value: 'gast'}, {label: 'Gesamt', value: 'total'} ],
            showByTeam: false,
            sortBy: ['totalSchnittT', 'totalSpieleT'],
            sortDesc: [true, true],
            //https://stackoverflow.com/questions/61682067/get-current-sort-options-when-sort-changes-in-vuetify-data-tables
            headers: [],
            selectedSpieler: null,
            selectedSpielerPassNr: null,
            selectedTeam: null,
        // schnittliste raw document incl unsubscribe
            schnittlisteHRaw: null,
            schnittlisteFRaw: null,
            unsubscribeH: null,
            unsubscribeF: null,
        // excel download
            headersExcel: [
                { text: 'Pass', value: 'passNr' },
                { text: 'Name', value: 'name' },
                { text: 'Verein', value: 'verein' },
                { text: 'Mannschaft', value: 'team' },
                { text: 'Nationalität', value: 'nationalitaet' },
                { text: 'Heimspiele', value: 'heimSpieleT' },
                { text: 'Heimschmitt', value: 'heimSchnittT' },
                { text: 'Gastspiele', value: 'gastSpieleT' },
                { text: 'Gastschnitt', value: 'gastSchnittT' },
                { text: 'Spiele', value: 'totalSpieleT' },
                { text: 'Schnitt', value: 'totalSchnittT' },
                { text: 'Heimspiele Herbst', value: 'heimSpieleH' },
                { text: 'Heimschmitt Herbst', value: 'heimSchnittH' },
                { text: 'Gastspiele Herbst', value: 'gastSpieleH' },
                { text: 'Gastschnitt Herbst', value: 'gastSchnittH' },
                { text: 'Spiele Herbst', value: 'totalSpieleH' },
                { text: 'Schnitt Herbst', value: 'totalSchnittH' },
                { text: 'Heimspiele Frühjahr', value: 'heimSpieleF' },
                { text: 'Heimschmitt Frühjahr', value: 'heimSchnittF' },
                { text: 'Gastspiele Frühjahr', value: 'gastSpieleF' },
                { text: 'Gastschnitt Frühjahr', value: 'gastSchnittF' },
                { text: 'Spiele Frühjahr', value: 'totalSpieleF' },
                { text: 'Schnitt Frühjahr', value: 'totalSchnittF' },
            ]
        }),
        created(){
            console.log ("CREATED Schnittlisten" );
            if ( this.$store.state.local.printBackReset ) {
                this.search = this.$store.state.local.printBackReset.search ?
                            this.$store.state.local.printBackReset.search : '';
                this.location = this.$store.state.local.printBackReset.location ?
                            this.$store.state.local.printBackReset.location : 'total';
                this.timeFrame = this.$store.state.local.printBackReset.timeFrame ?
                            this.$store.state.local.printBackReset.timeFrame : 'T';
                this.showByTeam = this.$store.state.local.printBackReset.showByTeam;
                this.roundFrom = this.$store.state.local.printBackReset.roundFrom;
                this.roundUntil = this.$store.state.local.printBackReset.roundUntil;
            }
            this.$store.state.local.printBackReset = null;
            this.setData();
            this.bindSchnittlistenRaw();
        },
        destroyed(){
            this.unsubscribeH();
            this.unsubscribeF();
        },
        methods: {
            quickSearch(content){
                this.search = this.search === content ? '' : content;
            },
            getAltersklasse(spieler){
                return SpielService.getAltersklasse(spieler.akHJ, spieler.akJahr, this.saison.id)
            },
            bindSchnittlistenRaw(){
                if ( this.unsubscribeH ) { this.unsubscribeH(); }
                if ( this.unsubscribeF ) { this.unsubscribeF(); }
                this.schnittlisteHRaw = null;
                this.schnittlisteFRaw = null;
                this.bindSchnittlisteRawSemester('schnittlisteH', 'unsubscribeH', 'H');
                this.bindSchnittlisteRawSemester('schnittlisteF', 'unsubscribeF', 'F');
            },
            bindSchnittlisteRawSemester(schnittliste, unsubscribe, semester){
                console.log ("bind" + schnittliste + "Raw", this.saison.id);
                this[unsubscribe] = db.collection('saisonen/' + this.saison.id + '/schnittliste')
                    .doc(this.saison.id + semester)
                    .onSnapshot((doc) => {
                        const dataField = schnittliste + 'Raw';
                        this[dataField] = doc.data();
                        if ( this[dataField] ) { this[dataField].id = doc.id; }
                    });
            },
            setSort(){
                const spiele = this.location + 'Spiele' + this.timeFrame;
                const schnitt = this.location + 'Schnitt' + this.timeFrame;
                this.sortBy = [schnitt, spiele];
            },
            setData(){
                this.headers = [
                    { text: '', value: 'pos', sortable: false},
                    { text: '', value: 'nationalitaet', sortable: false},
                    { text: 'PassNr', value: 'passNr', sortable: false,},
                    { text: '', value: 'ak', sortable: false},
                    { text: 'Name', value: 'name', sortable: false},
                    { text: 'Verein', value: 'verein', sortable: false},
                    { text: 'Team', value: 'team', sortable: false},
                    { text: 'Heim', value: 'heimSchnittT', sortable: false, align: 'center'},
                    { text: 'Spiele', value: 'heimSpieleT', sortable: false, align: 'center'},
                    { text: 'Gast', value: 'gastSchnittT', sortable: false, align: 'center'},
                    { text: 'Spiele', value: 'gastSpieleT', sortable: false, align: 'center'},
                    { text: 'Gesamt', value: 'totalSchnittT', sortable: false, align: 'center'},
                    { text: 'Spiele', value: 'totalSpieleT', sortable: false, align: 'center'},
                ];
                this.sortBy = [];
                this.setSort();
            },
            tableAction (id, passNr, team, key){
                this.selectedSpieler = id;
                this.selectedSpielerPassNr = passNr;
                this.selectedTeam = team;
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = key;
                this.$router.push({path: p, query: q});
            },
            print(){
                this.$store.state.local.printContainer = {
                    /*
                    header: '',
                    lvId: '', //this.landesverbandLocal.name + ' ' + this.sportJahr.replace('_', '/'),
                    content: '',//this.saisonenWithRanking,
*/
                    headers: this.headers,
                    schnittliste: this.schnittliste,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc,
                    search: this.search,
                    location: this.location,
                    timeFrame: this.timeFrame,
                    saison: this.saison,
                    flags: this.flags,
                    showByTeam: this.showByTeam,
                    roundFrom: this.roundFrom,
                    roundUntil: this.roundUntil,
                };
                console.log ("this.$store.state.local.printContainer", JSON.parse(JSON.stringify(this.$store.state.local.printContainer)));
                this.$router.push('/Ergebnisdienst/PrintSchnittliste');
            },
            resetSelectedSpieler(){
                this.selectedSpieler = null;
                this.selectedSpielerPassNr = null;
                this.selectedTeam = null;
            },
            calculateSchnittlisten(by){
                if ( this.schnittlisteHRaw && this.schnittlisteFRaw ) {
                    console.log ("WATCH " + by );
                    this.saison.calculateSchnittlisten(
                        this.schnittlisteHRaw, this.schnittlisteFRaw, this.showByTeam,
                        this.roundFrom, this.roundUntil
                    )
                }
                this.resetSelectedSpieler();
            }
        },
        watch: {
            location(){
                this.spieleMin = 0; // necessary to get records
                this.setSort();
                this.resetSelectedSpieler();
            },
            showByTeam(){ this.calculateSchnittlisten('show by team'); },
            roundFrom(){ this.calculateSchnittlisten('round from'); },
            roundUntil(){ this.calculateSchnittlisten('round until'); },
            schnittlisteHRaw(){this.calculateSchnittlisten('schnittlisteHRaw'); },
            schnittlisteFRaw(){this.calculateSchnittlisten('schnittlisteFRaw'); },
            timeFrame(){
                this.spieleMin = 0; // necessary to get records
                this.setData();
                this.resetSelectedSpieler();
            },
            anzahlSpiele(){
                if ( this.anzahlSpiele[this.anzahlSpiele.length-1] < this.spieleMin ||
                    !this.spieleMin) {
                    this.spieleMin = 1;
                }
                this.resetSelectedSpieler();
            },

        // refresh schnittlisten subscription
            saison: {
                handler(to, from){
                    if ( to && !from ) { //|| (to.id !== from.id)
                        console.log ("WATCH SAISON IN SCHNITTLISTE", this.$route.query.itemId);
                        this.bindSchnittlistenRaw();
                    }
                },
                deep: true
            },
        }
    }
</script>

<style scoped>
    .headerCell { font-size: 12px; font-weight: 600; color: #777;
                    border-bottom: solid #ddd 1px;}
    .linkCol {cursor: pointer}
    .borderRight {border-right: solid 1px lightgrey}
    .flagHover{ border-bottom: solid 1px white }
    .numberInput { width: 85px}
</style>